import { useRef } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";
import { useSite } from "../../context/SiteContext";
import { Reveal } from "../Reveal";
import { PlusButton } from "../PlusButton";
import FieldLines from "../FieldLines";

export default function FinalCta() {
    const { site, tx } = useSite();
    const c = site?.content || {};
    const ref = useRef(null);
    const mx = useMotionValue(0);
    const my = useMotionValue(0);
    const x = useSpring(mx, { stiffness: 60, damping: 15 });
    const y = useSpring(my, { stiffness: 60, damping: 15 });

    const onMove = (e) => {
        const r = ref.current?.getBoundingClientRect();
        if (!r) return;
        mx.set((e.clientX - r.left - r.width / 2) / 12);
        my.set((e.clientY - r.top - r.height / 2) / 12);
    };

    const lines = [c.cta_line1, c.cta_line2, c.cta_line3, c.cta_line4];

    return (
        <section
            ref={ref}
            id="cta"
            data-testid="final-cta-section"
            onMouseMove={onMove}
            className="grain relative overflow-hidden bg-[#D60024] px-6 py-32 text-[#0A0A0A] md:px-12 md:py-56 lg:px-24"
        >
            <FieldLines className="absolute -left-56 -top-56 h-[40rem] w-[40rem]" stroke="rgba(10,10,10,0.18)" accent={false} />
            <motion.span style={{ x, y }} aria-hidden="true" className="font-display absolute bottom-10 right-10 select-none text-[10rem] leading-none text-black/15 md:text-[16rem]">
                +
            </motion.span>

            <div className="relative">
                <h2 className="font-display text-[clamp(3.6rem,11vw,11rem)] leading-[0.85]" data-testid="final-cta-title">
                    {lines.map((l, i) => (
                        <Reveal key={i} delay={i * 0.07}>
                            <span className={`block ${i === 3 ? "text-white" : ""}`}>{tx(l)}</span>
                        </Reveal>
                    ))}
                </h2>
                <Reveal delay={0.3}>
                    <p className="mt-10 max-w-md text-base font-medium leading-relaxed text-black/75" data-testid="final-cta-text">
                        {tx(c.cta_text)}
                    </p>
                </Reveal>
                <Reveal delay={0.4}>
                    <div className="mt-12">
                        <PlusButton href="#contact" label={tx(c.cta_button) || "LET'S TALK"} testId="final-cta-button" variant="black" />
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
